export const DevConfig = {
  API_BASE_URL: "/api",
  PDF_BASE_URL: "https://telemoa.com/pdf",
  TELEGRAM_URL: "https://t.me",
  NAVER_WEB: "https://blog.naver.com",
  NAVER_MOBILE: "https://m.blog.naver.com",
};
  
export const ProductionConfig = {
  API_BASE_URL: "https://api.telemoa.com",
  PDF_BASE_URL: "https://rudolphlabs.co.kr/pdf",
};